module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "switch",
    class: _vm.switchBool === false ? 'switch-off' : 'switch-on',
    on: {
      "click": _vm.toggle
    }
  }, [_vm._c('div', {
    staticClass: "block"
  }), _vm._c('span', [_vm._v(_vm._s(_vm.switchBool === false ? _vm.offText : _vm.onText))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-65e79c46!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/controls/BoolSwitch.vue
// module id = 672
// module chunks = 1